<template>
    <div class="todo-list">
        <div class="todo-list-head">
            <h1>待辦清單</h1>
            <div class="todo-list-filter">
                <rent-select class="select-scroll" refName="county" :selectMsg="address.county.msg" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff">
                    <ul>
                        <li :data-id="index" :data-name="county" v-for="(county, index) in countyResult" :key="index">
                            {{county}}
                        </li>
                    </ul>
                </rent-select>
                <rent-select class="select-scroll" refName="district" :selectMsg="address.district.msg" @getId="getSelectId" :setDefault="address.district.state" border="1px solid #d5dad8" bgColor="#fff">
                    <ul v-if="countyId">
                        <li :data-id="district.districtCid" :data-name="district.districtName" v-for="(district, index) in districtsResult" :key="index">
                            {{district.districtName}}
                        </li>
                    </ul>
                </rent-select>
                <rent-select class="select-scroll select-road" refName="road" :selectMsg="address.road.msg" @getId="getSelectId" :setDefault="address.road.state" border="1px solid #d5dad8" bgColor="#fff">
                    <ul v-if="districtId">
                        <div class="road-filter">
                            <img class="search" src="../../../assets/img/icon/search_gray.svg" alt="">
                            <input v-model="selectRoad" placeholder="搜尋路段" type="text">
                        </div>
                        <li :data-id="index" :data-name="road.roadStreetName" v-for="(road, index) in filterRoad" :key="index">
                            {{road.roadStreetName}}
                        </li>
                    </ul>
                </rent-select>
            </div>
            <tabs>
                <tab name="全部" :selected="true">
                    <ul>
                        <li v-for="(houseItem, index) in filterByRoad" :key="index">
                            <!-- {{houseItem}} -->
                            <span class="order">{{index + 1}}.</span>
                            <span class="house-name">{{houseItem.name}}</span>
                            <span class="description">尚未上傳完整圖片</span>
                            <span class="address">
                                <img src="../../../assets/img/icon/address_gray.svg" alt="">
                                {{houseItem.address}}
                            </span>
                            <span class="action">
                                操作
                                <img src="../../../assets/img/icon/arrow_right_gray.svg" alt="">
                            </span>
                        </li>
                    </ul>
                </tab>
                <tab name="評價房客">
                    <ul>
                        <li v-for="(houseItem, index) in filterByEvaluation" :key="index">
                            <!-- {{houseItem}} -->
                            <span class="order">{{index + 1}}.</span>
                            <span class="house-name">{{houseItem.name}}</span>
                            <span class="description">尚未上傳完整圖片</span>
                            <span class="address">
                                <img src="../../../assets/img/icon/address_gray.svg" alt="">
                                {{houseItem.address}}
                            </span>
                            <span class="action">
                                操作
                                <img src="../../../assets/img/icon/arrow_right_gray.svg" alt="">
                            </span>
                        </li>
                    </ul>
                </tab>
                <tab name="退租點交">
                    <ul>
                        <li v-for="(houseItem, index) in filterByLeaseBack" :key="index">
                            <!-- {{houseItem}} -->
                            <span class="order">{{index + 1}}.</span>
                            <span class="house-name">{{houseItem.name}}</span>
                            <span class="description">尚未上傳完整圖片</span>
                            <span class="address">
                                <img src="../../../assets/img/icon/address_gray.svg" alt="">
                                {{houseItem.address}}
                            </span>
                            <span class="action">
                                操作
                                <img src="../../../assets/img/icon/arrow_right_gray.svg" alt="">
                            </span>
                        </li>
                    </ul>
                </tab>
                <tab name="發起續租">
                    <ul>
                        <li v-for="(houseItem, index) in filterByLeaseRenew" :key="index">
                            <!-- {{houseItem}} -->
                            <span class="order">{{index + 1}}.</span>
                            <span class="house-name">{{houseItem.name}}</span>
                            <span class="description">尚未上傳完整圖片</span>
                            <span class="address">
                                <img src="../../../assets/img/icon/address_gray.svg" alt="">
                                {{houseItem.address}}
                            </span>
                            <span class="action">
                                操作
                                <img src="../../../assets/img/icon/arrow_right_gray.svg" alt="">
                            </span>
                        </li>
                    </ul>
                </tab>
                <tab name="簽署合約">
                    <ul>
                        <li v-for="(houseItem, index) in filterBySignedContract" :key="index">
                            <!-- {{houseItem}} -->
                            <span class="order">{{index + 1}}.</span>
                            <span class="house-name">{{houseItem.name}}</span>
                            <span class="description">尚未上傳完整圖片</span>
                            <span class="address">
                                <img src="../../../assets/img/icon/address_gray.svg" alt="">
                                {{houseItem.address}}
                            </span>
                            <span class="action">
                                操作
                                <img src="../../../assets/img/icon/arrow_right_gray.svg" alt="">
                            </span>
                        </li>
                    </ul>
                </tab>
                <tab name="欠款催繳">
                    <ul>
                        <li v-for="(houseItem, index) in filterByArrears" :key="index">
                            <!-- {{houseItem}} -->
                            <span class="order">{{index + 1}}.</span>
                            <span class="house-name">{{houseItem.name}}</span>
                            <span class="description">尚未上傳完整圖片</span>
                            <span class="address">
                                <img src="../../../assets/img/icon/address_gray.svg" alt="">
                                {{houseItem.address}}
                            </span>
                            <span class="action">
                                操作
                                <img src="../../../assets/img/icon/arrow_right_gray.svg" alt="">
                            </span>
                        </li>
                    </ul>
                </tab>
                <tab name="收款提醒">
                    <ul>
                        <li v-for="(houseItem, index) in filterByRentAlarm" :key="index">
                            <!-- {{houseItem}} -->
                            <span class="order">{{index + 1}}.</span>
                            <span class="house-name">{{houseItem.name}}</span>
                            <span class="description">尚未上傳完整圖片</span>
                            <span class="address">
                                <img src="../../../assets/img/icon/address_gray.svg" alt="">
                                {{houseItem.address}}
                            </span>
                            <span class="action">
                                操作
                                <img src="../../../assets/img/icon/arrow_right_gray.svg" alt="">
                            </span>
                        </li>
                    </ul>
                </tab>
                <tab name="其他">
                    <ul>
                        <li v-for="(houseItem, index) in filterByOther" :key="index">
                            <!-- {{houseItem}} -->
                            <span class="order">{{index + 1}}.</span>
                            <span class="house-name">{{houseItem.name}}</span>
                            <span class="description">尚未上傳完整圖片</span>
                            <span class="address">
                                <img src="../../../assets/img/icon/address_gray.svg" alt="">
                                {{houseItem.address}}
                            </span>
                            <span class="action">
                                操作
                                <img src="../../../assets/img/icon/arrow_right_gray.svg" alt="">
                            </span>
                        </li>
                    </ul>
                </tab>
            </tabs>
            {{concatHouse}}
        </div>
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            houseItemList: [],
            countyId: '',
            countyName: '',
            districtId: '',
            districtName: '',
            roadId: '',
            roadName: '',
            selectRoad: null,
            address: {
                county: {
                    state: false,
                    msg: '所有縣市'
                },
                district: {
                    state: false,
                    msg: '所有區域'
                },
                road: {
                    state: false,
                    msg: '所有路段'
                }
            },
        }
    },
    methods: {
        getSelectId: function (value) {
            // this.filterState = 1
            // console.log(value)
            if( value.ref == 'county' ){
                // this.filter.county = value.name
                this.address.district.state = true
                this.address.road.state = true
                this.districtId = null
                this.districtName = null
                this.roadId = null
                this.roadName = null

                this.countyId = value.id
                this.countyName = value.name
                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if( value.ref == 'district' ){
                this.address.road.state = true
                this.roadId = null
                this.roadName = null
                this.address.district.state = false
                this.districtId = value.id
                this.districtName = value.name
                this.$store.dispatch('getRoad',(parseInt(value.id)+1))
            }else if( value.ref == 'road' ){
                this.address.road.state = false
                this.roadId = value.id
                this.roadName = value.name
                // this.filter.houseType = value.id
            }
        },
    },
    computed: {
        filterByCounty: function () {
            return this.houseResult.filter((houseItem) => {
                if( this.countyName ){
                    if(houseItem.county.includes(this.countyName) == true){
                        (houseItem)
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((houseItem) => {
                if( this.districtName ){
                    if(houseItem.district.includes(this.districtName) == true){
                        (houseItem)
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        concatHouse: function () {
            let houseItem = []
            for (let i = 0; i < this.filterByDistrict.length; i++) {
                // (this.houseResult)
                const house = this.filterByDistrict[i].houseList;
                houseItem = houseItem.concat(house)
            }
            this.houseItemList = houseItem
        },
        filterByRoad: function () {
            return this.houseItemList.filter((houseItem) => {
                if( this.roadName ){
                    if(houseItem.road.includes(this.roadName) == true){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterBySignedContract: function () {
            return this.filterByRoad.filter((houseItem) => {
                // (houseItem)
                if(houseItem.status.includes(0)){
                    return houseItem
                }
            });
        },
        // filterByEvaluation: function () {
        //     return this.houseItemList.filter((houseItem) => {
        //         console.log(houseItem)
        //         if(houseItem.status.includes(1)){
        //             return houseItem
        //         }
        //     });
        // },
        filterByArrears: function () {
            return this.houseItemList.filter((houseItem) => {
                if(houseItem.status.includes(2)){
                    return houseItem
                }
            });
        },
        filterByLeaseRenew: function () {
            return this.houseItemList.filter((houseItem) => {
                if(houseItem.status.includes(3)){
                    return houseItem
                }
            });
        },
        filterByRentAlarm: function () {
            return this.houseItemList.filter((houseItem) => {
                if(houseItem.status.includes(4)){
                    return houseItem
                }
            });
        },
        filterByEvaluation: function () {
            return this.houseItemList.filter((houseItem) => {
                if(houseItem.status.includes(5)){
                    return houseItem
                }
            });
        },
        filterByLeaseBack: function () {
            return this.houseItemList.filter((houseItem) => {
                if(houseItem.status.includes(6)){
                    return houseItem
                }
            });
        },
        filterByOther: function () {
            return this.houseItemList.filter((houseItem) => {
                if(houseItem.status.includes(7)){
                    return houseItem
                }
            });
        },
        filterRoad: function () {
            return this.roads.filter((road) => {
                // console.log(road.roadStreetName)
                if( this.selectRoad ){
                    if(road.roadStreetName.includes(this.selectRoad)){
                        return road
                    }
                }else{
                    return road
                }
            });
        },
        ...mapGetters({
            houseResult: 'HOUSE_RESULT',
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
        })
    },
    components: {
        Tabs,
        Tab,
        RentSelect
    }
}
</script>
<style lang="scss" scoped>
    .todo-list{
        width: 1176px;
        .todo-list-head{
            .tabs{
                position: absolute;
                top: 0px;
                left: 152px;
                ul li.is-active :after{
                    bottom: -4px;
                }
            }
            .tabs-details{
                div{
                    height: 608px;
                    overflow-x: hidden;
                    ul{
                        li{
                            position: relative;
                            display: flex;
                            align-items: center;
                            padding: 18px 0;
                            border-bottom:1px solid #f1f5f4;
                            span{
                                display: flex;
                                align-items: center; 
                            }
                            .order{
                                margin-right: 12px;
                            }
                            .house-name{
                                width: 280px;
                                color: #ff9275;
                                margin-right: 60px;
                            }
                            .description{
                                width: 200px;
                            }
                            .address{
                                width: 300px;
                            }
                            .action{
                                position: absolute;
                                right: 0;
                                font-size: 12px;
                                color: #cacfcd;
                            }
                        }
                    }
                }
                
            }
            .todo-list-filter{
                display: flex;
                margin-top: 24px;
                margin-bottom: 42px;
                .rent-select{
                    width: 75px;
                    margin-right: 16px;
                }
                .select-road{
                    width: 174px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/TodoList.vue